// extracted by mini-css-extract-plugin
export default {"game":"game_game__93mJs","ui":"game_ui__ecGBi","pano":"game_pano__fu-c1","minimap":"game_minimap__E7k1i","place_point":"game_place_point__ZXmzH"};